import { createSlice } from "@reduxjs/toolkit";
import Api from "../../api/Api";
import {IObjectKeys} from "../../constants/interfaces";

type State = {
	data: IObjectKeys,
	isLoading: boolean,
	error: Object | null
}

// Slice
const slice = createSlice({
	name: "chart",
	initialState: {
		data: {},
		isLoading: false,
		error: null,
	},
	reducers: {
		fetchChartStart: (state: State) => {
			state.isLoading = true;
		},
		fetchChartSuccess: (state: State, action) => {
			state.isLoading = false;
			state.data[action.payload.cellId] = action.payload.data;
		},
		fetchChartFailed: (state: State, action) => {
			state.isLoading = false;
			state.error = action.payload;
		},
		resetToInitialState: (state : State) => {
			state.data = {};
			state.isLoading = false;
			state.error = null;
		}
	},
});

export default slice.reducer;

// Actions
const {
	fetchChartStart, 
	fetchChartSuccess, 
	fetchChartFailed,
	resetToInitialState
} = slice.actions;

export const getChart = (metric: string, brands: string, interval: string, sections: string, tags: string, conversions: string, eventFields: string, isPaid: string, videoFilter: string, pageType: string, referrers: string, referrerTypes: string, includeChannels: string, excludeChannels: string, pubdateInterval: string, userNeeds:string, cellId: number) => async (dispatch: Function) => {
	try {
		dispatch(fetchChartStart());
		const api = new Api();
		const result = await api.getChart(metric, brands, interval, sections, tags, conversions, eventFields, isPaid, videoFilter, pageType, referrers, referrerTypes, includeChannels, excludeChannels, pubdateInterval, userNeeds);
		const payload = {
			data: result,
			metric,
			cellId
		}
		if (result !== "No internet connection") { 
			dispatch(fetchChartSuccess(payload));
		}
	} catch (err: any) {
		dispatch(fetchChartFailed(err));
	}
};

export const resetChartState = () => async (dispatch: Function) => {
	dispatch(resetToInitialState())
}